import React, { useEffect, useMemo, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

// antd
import { Dropdown, Menu } from 'antd'
import { Icon } from '@iconify/react'

// styles
import styles from './navigation.module.css'

// navigationRoute
import SuperAdminRoutesNavigation from './superAdminRoutesNavigation'
import MemberRoutesNavigation from './memberRoutesNavigation'

const Navigation = () => {
    const nav = useNavigate()
    const { pathname } = useLocation()

    const [selected, setSelected] = useState()

    const navigate = async (key, route) => {
        if (route) nav(route)
    }

    useEffect(() => {
        const segment = pathname.split('/')[2]
        const subSegment = pathname.split('/')[3]
        setSelected(subSegment === 'test-run' ? 'test-run' : segment)
    }, [pathname])

    const superItems = SuperAdminRoutesNavigation()
    const memberItems = MemberRoutesNavigation(selected)

    const items = useMemo(
        () => [...superItems, ...memberItems],
        [superItems, memberItems]
    )

    const itemsWithContextMenu = useMemo(() => {
        return (items || []).map((item) => {
            if (!item?.route) return item

            return {
                ...item,
                label: (
                    <Dropdown
                        trigger={['contextMenu']}
                        placement="bottomLeft"
                        overlayClassName={styles.navContextDropdown}
                        menu={{
                            items: [
                                {
                                    key: 'open-new-tab',
                                    label: (
                                        <span
                                            className={styles.contextMenuItem}
                                        >
                                            <Icon
                                                icon="fluent:open-48-filled"
                                                className={
                                                    styles.contextMenuIcon
                                                }
                                            />
                                            <span>Open in new tab</span>
                                        </span>
                                    ),
                                    onClick: (e) => {
                                        e?.domEvent?.stopPropagation?.()
                                        window.open(
                                            item.route,
                                            '_blank',
                                            'noopener,noreferrer'
                                        )
                                    },
                                },
                            ],
                        }}
                    >
                        <span
                            className={styles.contextMenuTarget}
                            onContextMenu={(e) => e.preventDefault()}
                        >
                            {item.label}
                        </span>
                    </Dropdown>
                ),
            }
        })
    }, [items])

    return (
        <>
            <Menu
                theme="dark"
                mode="inline"
                items={itemsWithContextMenu}
                className={styles.menu}
                style={{
                    fontSize: 14,
                    color: '#cbd5e1',
                    background: 'transparent',
                    fontWeight: 400,
                }}
                selectedKeys={[selected]}
                onClick={(data) => {
                    const route = data?.item?.props?.route
                    if (route) {
                        navigate(data?.key, route)
                        setSelected(data?.key)
                    }
                }}
            />
        </>
    )
}

export default Navigation
